export const REFERRAL_STATUS = {
  PENDING: 'Pending',
  APPOINTMENT_COMPLETE: 'Appointment Complete',
  JOB_COMPLETE: 'Job Complete',
  CANCELLED: 'Cancelled',
} as const

export type ReferralStatus =
  (typeof REFERRAL_STATUS)[keyof typeof REFERRAL_STATUS]

const STATUS_ALIASES: Record<string, ReferralStatus> = {
  Pending: REFERRAL_STATUS.PENDING,
  Scheduled: REFERRAL_STATUS.APPOINTMENT_COMPLETE,
  'Appointment Done': REFERRAL_STATUS.APPOINTMENT_COMPLETE,
  'Appointment Completed': REFERRAL_STATUS.APPOINTMENT_COMPLETE,
  'Appointment Complete': REFERRAL_STATUS.APPOINTMENT_COMPLETE,
  Completed: REFERRAL_STATUS.JOB_COMPLETE,
  'Job Completed': REFERRAL_STATUS.JOB_COMPLETE,
  'Job Complete': REFERRAL_STATUS.JOB_COMPLETE,
  Cancelled: REFERRAL_STATUS.CANCELLED,
  Canceled: REFERRAL_STATUS.CANCELLED,
}

export function normalizeReferralStatus(status: string): ReferralStatus {
  return STATUS_ALIASES[status] ?? REFERRAL_STATUS.PENDING
}
